module.exports = __webpack_public_path__ + "static/media/practicaAutosClusters.969a5a6f.r";